import { RouteConfig } from "vue-router";
import localizationFactory from "@/router/modules/localization-factory";

export default <RouteConfig> {
	path: "/card-replenishment",
	name: "CardReplenishment",
	meta: localizationFactory('companyAccounts.replenish.card', {
		layout: "main"
	}),
	component: () => import('../../../views/Home/CardReplenishment.vue')
}